import script from "./ClubGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClubGallery.vue?vue&type=script&setup=true&lang=ts"

import "./ClubGallery.vue?vue&type=style&index=0&id=2e313228&lang=scss"

export default script